import React, { Component, Fragment } from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';

import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import {
  DetailsList,
  DetailsListLayoutMode,
} from 'office-ui-fabric-react/lib/DetailsList';
import { Link } from 'office-ui-fabric-react/lib/Link';

import { localizable } from 'components/Localization';
import Loading from 'components/LoadingOverlay';
import GuideOverlay from 'components/GuideOverlay';
import SaleCreatePanel from 'components/SaleCreatePanel';

import styled from 'styled-components';

const Badge = styled.span`
  background: grey;
  margin-right: 0.5em;
  border-radius: 3px;
  color: #fff;
  font-size: 0.8em;
  padding: 2px 4px;
`;

// @inject('listings', 'saleCreate', 'user', 'inventory', 'app')
@inject('listings', 'user', 'inventory', 'app')
@localizable
@observer
class ListingsOverview extends Component {
  @observable creating = false;
  @observable isTest = false;

  componentWillMount() {
    const { listings, t } = this.props;
    listings.load();
    listings.initColumns(t, this.handleColumnHeaderClick);
  }

  handleAddNew = () => {
    const { history } = this.props;
    history.push(`/dashboard/search`);
  };

  handleMls = () => {
    const { history } = this.props;
    history.push(`/dashboard/mls`);
  };

  handleColumnHeaderClick = (e, column) => {
    const { listings } = this.props;
    listings.sortBy(column.fieldName);
  };

  handleRenderObjectColumn = (item, index, column) => {
    const content = item[column.fieldName];
    const { roundNumber, roundType, roundStatus, whitelistedAgentStatus } =
      item;
    const { t } = this.props;
    const hasAccess = true;
    // (!item.whitelistedAgentId && !item.whitelistedAgentStatus) ||
    // whitelistedAgentStatus === 'whitelisted';
    switch (column.key) {
      case 'itemNumber':
        return hasAccess ? (
          <Link data-selection-invoke={true}>{content}</Link>
        ) : (
          <span>{content}</span>
        );
      case 'status':
        return (
          <span content={content}>
            {t('statusvalue', {
              whitelistedAgentStatus,
              content,
              roundNumber,
              roundType,
              roundStatus,
            })}
          </span>
        );
      case 'startAt':
      case 'endAt':
        return <span>{content ? content.toFormatedDateString() : ''}</span>;
      case 'title':
        return (
          <span>
            {item.features && item.features.test && <Badge>TEST</Badge>}
            <Link data-selection-invoke={true}>{content}</Link>
          </span>
        );
      default:
        return <span>{content}</span>;
    }
  };

  handleItemInvoked = (item, index) => {
    const { history } = this.props;
    // const hasAccess =
    //   (!item.whitelistedAgentId && !item.whitelistedAgentStatus) ||
    //   item.whitelistedAgentStatus === 'whitelisted';
    // if (hasAccess)

    history.push(`/dashboard/${item.id}`);
  };

  handleStartSale = (isTest) => () => {
    const { history, app } = this.props;

    if (
      app.config.inventory &&
      app.config.inventory.url &&
      app.features &&
      app.features.createSaleFromInventory
    )
      history.push(`/dashboard/search${isTest ? '?test=1' : ''}`);
    else {
      this.creating = true;
      this.isTest = isTest;
    }
  };

  render() {
    const { app, listings, inventory, history, t, user } = this.props;
    if (inventory.redirect) {
      history.push(`/dashboard/${inventory.startedSale}`);
    }

    let commands = [];

    if (app.features) {
      if (
        (app.config.inventory &&
          app.config.inventory.url &&
          app.features &&
          app.features.createSaleFromInventory) ||
        app.features.createBlankSale
      ) {
        commands.push({
          key: 'create',
          name: t('Start new sale'),
          iconProps: {
            iconName: 'Add',
          },
          onClick: this.handleStartSale(false),
          disabled: !user.hasReadWritePermissions,
        });

        if (app.features.createTestSale) {
          commands.push({
            key: 'create-test',
            name: t('Start new test sale'),
            iconProps: {
              iconName: 'TestBeaker',
            },
            onClick: this.handleStartSale(true),
            disabled: !user.hasReadWritePermissions,
          });
        }
      }
    }

    if (app.canMls) {
      commands.push({
        key: 'mls',
        name: t('mls'),
        iconProps: {
          iconName: 'MultiSelect',
        },
        onClick: this.handleMls,
        disabled: !user.hasReadWritePermissions,
      });
    }

    return (
      <Fragment>
        <div className="title" style={{ whiteSpace: 'nowrap' }}>
          {t('My listings overview')}
        </div>
        <div className="menu">
          <CommandBar items={commands} />
        </div>
        <div className="content">
          {
            /* fetching */
            listings.fetching && (
              <div style={{ marginTop: 5 }}>
                <Loading label={t('Loading listings') + '...'} />
              </div>
            )
          }

          {
            /* no active listings */
            !listings.fetching &&
              (!listings.items || !listings.items.length) && (
                <GuideOverlay theme={app.theme}>
                  <span>
                    <p>{t('Guide - you should add a new listing')}</p>
                  </span>
                </GuideOverlay>
              )
          }

          {
            /* you have some active listings */
            !listings.fetching && listings.items && listings.items.length && (
              <DetailsList
                columns={listings.columns}
                items={listings.items}
                onRenderItemColumn={this.handleRenderObjectColumn}
                onItemInvoked={this.handleItemInvoked}
                selectionMode={1}
                checkboxVisibility={2}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                selectionPreservedOnEmptyClick={true}
              />
            )
          }

          {this.creating && (
            <SaleCreatePanel
              onClose={() => (this.creating = false)}
              isTest={this.isTest}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default ListingsOverview;



// WEBPACK FOOTER //
// ./src/app/containers/Overview/index.jsx